// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/img/LOGO-Icontec-2019_ver_black.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/ReportForm.css */

.report-form {
    font-family: Arial, sans-serif;
    max-width: 900px;
    margin: 0 auto;
    padding: 20px;
    border: 1px solid #ddd;
    background: #fff;
}

.report-form-header {
    text-align: center;
    margin-bottom: 20px;
}

.report-form-header h1 {
    font-size: 16px;
}

.header-info {
    display: flex;
    justify-content: space-between;
}

.header-info .left {
    font-weight: bold;
}

.header-info .right {
    text-align: right;
}

.form-section {
    margin-bottom: 20px;
}

.form-row {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
}

.form-row label {
    flex: 1 1;
}

.form-row input {
    margin-left: 10px;
    padding: 5px;
    border: 1px solid #ccc;
}

.cylinder-section {
    margin-bottom: 20px;
}

.cylinder-section table {
    width: 100%;
    border-collapse: collapse;
}

.cylinder-section th,
.cylinder-section td {
    border: 1px solid #ddd;
    padding: 10px;
    text-align: center;
}

.cylinder-section input {
    width: 100%;
    box-sizing: border-box;
    padding: 5px;
    border: none;
}

.report-footer {
    display: flex;
    justify-content: space-between;
}

.footer-info {
    display: flex;
    align-items: center;
}

.footer-info label {
    margin-right: 10px;
}

.footer-info input {
    padding: 5px;
    border: 1px solid #ccc;
}

.main-table {
    width: 100%;
    border-collapse: collapse;
}

.main-table td {
    vertical-align: top;

    width: 50%;
    /* Asegura que cada celda ocupe el 50% del ancho de la pantalla */
}

.header-table {
    width: 100%;
    border-collapse: collapse;
}

.header-table letra {
    vertical-align: top;
    width: 60%;
    /* Asegura que cada celda ocupe el 50% del ancho de la pantalla */
}

.header-table td-img {
    vertical-align: top;
    width: 40%;
    /* Asegura que cada celda ocupe el 50% del ancho de la pantalla */
}

.justificado {
    text-align: justify;
}

.custom-table {
    width: auto;
    height: auto;
    table-layout: fixed;
    border-collapse: collapse;
    margin: auto;
    /* Centra la tabla horizontalmente */
}

.custom-table td,
.custom-table th {
    border: 1px solid #000;
    padding: 8px;
    word-wrap: break-word;
}

.header-image img {
    max-width: 100%;
    height: auto;
}

.justificado {
    text-align: justify;
}

.icontec-bg {
    position: relative;
    /* Para que los pseudoelementos sean relativos a este elemento */
}

.icontec-bg::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center center;
    opacity: 0.1;
    /* Ajusta la opacidad según tus preferencias */
    z-index: -1;
    /* Asegura que el pseudoelemento esté detrás del contenido */
}`, "",{"version":3,"sources":["webpack://./src/assets/css/certificado.css"],"names":[],"mappings":"AAAA,kCAAkC;;AAElC;IACI,8BAA8B;IAC9B,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,yBAAyB;AAC7B;;AAEA;;IAEI,sBAAsB;IACtB,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,sBAAsB;IACtB,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;;IAEnB,UAAU;IACV,iEAAiE;AACrE;;AAEA;IACI,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,UAAU;IACV,iEAAiE;AACrE;;AAEA;IACI,mBAAmB;IACnB,UAAU;IACV,iEAAiE;AACrE;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,YAAY;IACZ,oCAAoC;AACxC;;AAEA;;IAEI,sBAAsB;IACtB,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,gEAAgE;AACpE;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,yDAAyE;IACzE,4BAA4B;IAC5B,wBAAwB;IACxB,kCAAkC;IAClC,YAAY;IACZ,8CAA8C;IAC9C,WAAW;IACX,4DAA4D;AAChE","sourcesContent":["/* src/components/ReportForm.css */\n\n.report-form {\n    font-family: Arial, sans-serif;\n    max-width: 900px;\n    margin: 0 auto;\n    padding: 20px;\n    border: 1px solid #ddd;\n    background: #fff;\n}\n\n.report-form-header {\n    text-align: center;\n    margin-bottom: 20px;\n}\n\n.report-form-header h1 {\n    font-size: 16px;\n}\n\n.header-info {\n    display: flex;\n    justify-content: space-between;\n}\n\n.header-info .left {\n    font-weight: bold;\n}\n\n.header-info .right {\n    text-align: right;\n}\n\n.form-section {\n    margin-bottom: 20px;\n}\n\n.form-row {\n    display: flex;\n    align-items: center;\n    margin-bottom: 10px;\n}\n\n.form-row label {\n    flex: 1;\n}\n\n.form-row input {\n    margin-left: 10px;\n    padding: 5px;\n    border: 1px solid #ccc;\n}\n\n.cylinder-section {\n    margin-bottom: 20px;\n}\n\n.cylinder-section table {\n    width: 100%;\n    border-collapse: collapse;\n}\n\n.cylinder-section th,\n.cylinder-section td {\n    border: 1px solid #ddd;\n    padding: 10px;\n    text-align: center;\n}\n\n.cylinder-section input {\n    width: 100%;\n    box-sizing: border-box;\n    padding: 5px;\n    border: none;\n}\n\n.report-footer {\n    display: flex;\n    justify-content: space-between;\n}\n\n.footer-info {\n    display: flex;\n    align-items: center;\n}\n\n.footer-info label {\n    margin-right: 10px;\n}\n\n.footer-info input {\n    padding: 5px;\n    border: 1px solid #ccc;\n}\n\n.main-table {\n    width: 100%;\n    border-collapse: collapse;\n}\n\n.main-table td {\n    vertical-align: top;\n\n    width: 50%;\n    /* Asegura que cada celda ocupe el 50% del ancho de la pantalla */\n}\n\n.header-table {\n    width: 100%;\n    border-collapse: collapse;\n}\n\n.header-table letra {\n    vertical-align: top;\n    width: 60%;\n    /* Asegura que cada celda ocupe el 50% del ancho de la pantalla */\n}\n\n.header-table td-img {\n    vertical-align: top;\n    width: 40%;\n    /* Asegura que cada celda ocupe el 50% del ancho de la pantalla */\n}\n\n.justificado {\n    text-align: justify;\n}\n\n.custom-table {\n    width: auto;\n    height: auto;\n    table-layout: fixed;\n    border-collapse: collapse;\n    margin: auto;\n    /* Centra la tabla horizontalmente */\n}\n\n.custom-table td,\n.custom-table th {\n    border: 1px solid #000;\n    padding: 8px;\n    word-wrap: break-word;\n}\n\n.header-image img {\n    max-width: 100%;\n    height: auto;\n}\n\n.justificado {\n    text-align: justify;\n}\n\n.icontec-bg {\n    position: relative;\n    /* Para que los pseudoelementos sean relativos a este elemento */\n}\n\n.icontec-bg::before {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-image: url('../../assets/img/LOGO-Icontec-2019_ver_black.png');\n    background-repeat: no-repeat;\n    background-size: contain;\n    background-position: center center;\n    opacity: 0.1;\n    /* Ajusta la opacidad según tus preferencias */\n    z-index: -1;\n    /* Asegura que el pseudoelemento esté detrás del contenido */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
